import notificationStore from '@/common/components/toast/store';
import { OptionalNotificationPayload } from '@/common/components/toast/store/actions';
import { Store } from 'vuex';

export async function showDelayedNotification(baseStore: Store<unknown>, payload: OptionalNotificationPayload) {
    await notificationStore.context(baseStore).actions.showDelayedNotification(payload);
}
